module.exports = __webpack_public_path__ + "media/plaintiffs/footer-51e8410d.jpg";